<template>
  <v-dialog
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    width="600"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card block flat>
      <v-card-title class="title pb-0">
        <span class="title">Send Tax Return Delivery</span>
      </v-card-title>
      <v-card-text>
        <v-layout column>
          <v-layout justify-center>
            <v-flex
              xs6
              id="new-tax-return-template-box"
              class="mr-2 send-tax-return-dialog__block"
              style="cursor: pointer"
              @click="
                $emit('update:opened', false);
                $emit('open-upload-tax-return-dialog');
              "
            >
              <v-layout column align-center>
                <i class="material-icons-outlined primary--text" size="40">
                  upload
                </i>
                <div class="primary--text subheading"><b>Upload</b></div>
                <div class="grey--text mt-2">
                  Upload a draft of the client's tax return
                </div>
              </v-layout>
            </v-flex>

            <v-flex
              xs6
              class="send-tax-return-dialog__block"
              style="cursor: pointer"
              @click="importFromTaxSoftware()"
            >
              <v-layout column align-center>
                <i class="material-icons-outlined primary--text" size="40">
                  computer
                </i>
                <div class="primary--text subheading">
                  <b>Import from Tax Software</b>
                </div>
                <div class="grey--text mt-2">
                  Soraban will auto-pull from your tax software
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <sx-button-group x-align="right" :is-full-width="true">
          <div @click="$emit('update:opened', false)">
            <sx-button type="secondary">
              {{ $t('cancel') }}
            </sx-button>
          </div>
        </sx-button-group>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';
import SxButton from '@/components/sx/SxButton';
import SxButtonGroup from '@/components/sx/SxButtonGroup';

export default {
  components: {
    SxButton,
    SxButtonGroup,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [FirmPreferenceMixins],
  methods: {
    importFromTaxSoftware() {
      this.$emit('update:opened', false);
      this.$emit('open-import-tax-return-dialog');
    },
  },
};
</script>

<style scoped="true">
.send-tax-return-dialog__block {
  padding: 24px 16px;

  background-color: var(--gray-25);
  border: 1px solid var(--gray-50) !important;
  border-radius: 4px;
  transition: all 120ms ease-in-out;
}

.send-tax-return-dialog__block:hover {
  border-color: var(--gray-100) !important;
  background-color: var(--gray-100);
}
</style>
